import { render, staticRenderFns } from "./ChannelBreakdown.vue?vue&type=template&id=c1a1cddc&scoped=true"
import script from "./ChannelBreakdown.vue?vue&type=script&lang=js"
export * from "./ChannelBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ChannelBreakdown.vue?vue&type=style&index=0&id=c1a1cddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a1cddc",
  null
  
)

export default component.exports